(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gk-back-in-stock"] && !Shopify.designMode) return;
  try {
    if (!window.__gkBackInStockV2) {
  window.__gkBackInStockV2 = true;
  const variantsCache = new WeakMap();
  const openers = new WeakMap();
  function variants(dialog) {
    if (!variantsCache.has(dialog)) {
      try { variantsCache.set(dialog, JSON.parse(dialog.querySelector('[data-gk-bis-variants]')?.textContent || '[]')); }
      catch (_) { variantsCache.set(dialog, []); }
    }
    return variantsCache.get(dialog);
  }
  function selected(dialog) {
    const form = document.getElementById(dialog.dataset.formId);
    const input = form?.querySelector('[name="id"]');
    const id = input ? input.value : dialog.dataset.variantId;
    return variants(dialog).find(item => String(item.id) === String(id));
  }
  function reset(dialog) {
    const form = dialog.querySelector('[data-gk-bis-form]');
    const button = form?.querySelector('[data-gk-bis-submit]');
    if (!form || !button) return;
    form.hidden = false;
    form.removeAttribute('aria-busy');
    dialog.querySelector('[data-gk-bis-success]').hidden = true;
    form.querySelector('[data-gk-bis-error]').hidden = true;
    button.disabled = false;
    if (button.dataset.originalLabel) button.textContent = button.dataset.originalLabel;
    delete dialog.dataset.subscribed;
  }
  function sync(dialog) {
    const variant = selected(dialog);
    const controls = document.getElementById(dialog.dataset.formId)?.querySelector('[data-gk-purchase-controls]');
    if (controls) {
      const waitButton = controls.querySelector('[data-gk-bis-open]');
      const buyWrapper = controls.querySelector('[data-gk-buy-wrapper]');
      const waiting = Boolean(variant && !variant.available);
      if (waitButton) waitButton.hidden = !waiting;
      if (buyWrapper) buyWrapper.hidden = waiting;
    }
    if (!variant) return null;
    if (String(variant.id) !== dialog.dataset.variantId) reset(dialog);
    dialog.dataset.variantId = String(variant.id);
    const title = dialog.querySelector('[data-gk-bis-variant-title]');
    title.textContent = variant.title;
    title.hidden = !variant.title || variant.title === 'Default Title';
    dialog.querySelector('[data-gk-bis-price]').textContent = variant.price;
    const image = dialog.querySelector('.gk-bis-product__media img');
    if (image && variant.image && image.getAttribute('src') !== variant.image) {
      image.removeAttribute('srcset');
      image.src = variant.image;
    }
    return variant;
  }
  function init(root = document) {
    const dialogs = root.matches?.('[data-gk-bis-dialog]') ? [root] : root.querySelectorAll?.('[data-gk-bis-dialog]') || [];
    dialogs.forEach(dialog => {
      sync(dialog);
      if (dialog.__gkBound) return;
      dialog.__gkBound = true;
      const form = document.getElementById(dialog.dataset.formId);
      form?.addEventListener('variant:change', () => requestAnimationFrame(() => sync(dialog)));
      form?.addEventListener('change', () => requestAnimationFrame(() => sync(dialog)));
      if (form) new MutationObserver(() => sync(dialog)).observe(form, {attributes:true,subtree:true,attributeFilter:['disabled']});
      dialog.addEventListener('close', () => { const opener = openers.get(dialog); if (opener?.isConnected) opener.focus(); });
    });
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const opener = event.target.closest('[data-gk-bis-open]');
    if (opener) {
      event.preventDefault();
      const dialog = document.getElementById(opener.dataset.gkBisOpen);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const variant = sync(dialog);
      if (!variant || variant.available) return;
      openers.set(dialog, opener);
      if (!dialog.open) dialog.showModal();
      requestAnimationFrame(() => dialog.querySelector(dialog.dataset.subscribed ? '[data-gk-bis-success] h3' : 'input[type="email"]')?.focus());
      return;
    }
    const closer = event.target.closest('[data-gk-bis-close]');
    if (closer) closer.closest('dialog')?.close();
    const dialog = event.target.closest('[data-gk-bis-dialog]');
    if (dialog && event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  document.addEventListener('submit', async event => {
    if (!(event.target instanceof HTMLFormElement) || !event.target.matches('[data-gk-bis-form]')) return;
    event.preventDefault();
    const form = event.target;
    if (form.getAttribute('aria-busy') === 'true' || !form.reportValidity()) return;
    const dialog = form.closest('[data-gk-bis-dialog]');
    const variant = sync(dialog);
    const errorBox = form.querySelector('[data-gk-bis-error]');
    if (!variant || variant.available) { errorBox.textContent = form.dataset.errorMessage; errorBox.hidden = false; return; }
    const email = form.elements.email.value.trim();
    const button = form.querySelector('[data-gk-bis-submit]');
    button.dataset.originalLabel ||= button.textContent;
    button.disabled = true;
    button.textContent = form.dataset.sendingLabel;
    form.setAttribute('aria-busy', 'true');
    errorBox.hidden = true;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    const payload = {data:{type:'back-in-stock-subscription',attributes:{profile:{data:{type:'profile',attributes:{email}}},channels:['EMAIL']},relationships:{variant:{data:{type:'catalog-variant',id:'$shopify:::$default:::' + variant.id}}}}};
    try {
      const response = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(dialog.dataset.companyId), {
        method:'POST',
        headers:{'Content-Type':'application/vnd.api+json','Accept':'application/vnd.api+json','revision':'2026-07-15'},
        body:JSON.stringify(payload), signal:controller.signal, credentials:'omit'
      });
      if (response.status !== 202) throw new Error('Subscription not accepted');
      if (dialog.dataset.variantId !== String(variant.id)) { reset(dialog); return; }
      form.hidden = true;
      dialog.dataset.subscribed = 'true';
      const success = dialog.querySelector('[data-gk-bis-success]');
      success.hidden = false;
      success.querySelector('h3')?.focus();
    } catch (_) {
      errorBox.textContent = form.dataset.errorMessage;
      errorBox.hidden = false;
      button.disabled = false;
      button.textContent = button.dataset.originalLabel;
    } finally { clearTimeout(timeout); form.removeAttribute('aria-busy'); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node instanceof Element && (node.matches('[data-gk-bis-dialog]') || node.querySelector('[data-gk-bis-dialog]'))) init(node);
    }
  }).observe(document.documentElement, {childList:true,subtree:true});
}
  } catch(e) { console.error(e); }
})();

})();
